export default function(api: GlobalFetch) {
  return async function(
    objectId,
    calendarId,
  ) {

    const response = await api.fetch(
      `/api/v2/pricemulti/index/id_object/${objectId}/id_calendar/${calendarId}/`,
    )
    return await handleResponse(response)
  }
}

export async function handleResponse(response) {
  const json = await response.json()
  return json.items
}
